<template>
  <v-container fluid>
    <v-form v-model="formValidity">
      <v-row>
        <v-toolbar dense>
          <v-btn text @click="$emit('user-type-cancel')">Annulla</v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!formValidity" @click="$emit('user-type-added')" color="accent">Avanti</v-btn>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col cols="8" md="6">
          <v-text-field
            v-model="user.nickname"
            :rules="nameRules"
            :hint="codiceCaso"
            placeholder="Nome o soprannome"
            persistent-hint
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2">
          <v-select
            v-model="user.sex"
            :items="['M', 'F']"
            label="Sesso"
            :rules="requiredRules"
            outlined
            dense
            required
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            type="number"
            v-model="user.height"
            label="Altezza"
            hint="cm"
            persistent-hint
            required
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            type="number"
            v-model="user.weight"
            label="Peso"
            hint="Kg"
            persistent-hint
            required
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="6">
          <v-select
            v-model="user.ageRange"
            :items="ageRange"
            :rules="requiredRules"
            label="Fascia di età"
          ></v-select>
        </v-col>

        <v-col cols="6">
          <v-text-field
            @change="user.bmi = bmi()"
            label="BMI"
            disabled
            v-model="bmiReading"
            persistent-hint
            hint="Indice di Massa Corporea"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {},
  computed: {
    bmi() {
      let h = this.user.height;
      h /= 100.0;
      h *= h;
      return this.user.weight * h > 0 ? this.user.weight / h : null;
    },
    bmiReading() {
      return this.bmi
        ? (Math.round(10 * this.bmi) * 0.1).toLocaleString("it-IT")
        : "";
    },
    bmiClass() {
      // not Working
      let c = "red";
      const b = this.bmi;
      if (b < 40) c = "orange";
      if (b < 30) c = "amber";
      if (b < 25) c = "green";
      if (b < 18.5) c = "indago";
      return c + "--text";
    },
    codiceCaso() {
      if (this.user.key) {
        return "codice caso: xxx-xxx-" + this.user.key.slice(-3);
      } else {
        return "codice caso: xxx-xxx-xxx";
      }
    }
  },
  data: () => ({
    formValidity: false,
    heightRules: [
      v => !!v || "L'altezza è utile per il fattore di rischio",
      v => v.length <= 3 || "Troppo lungo"
    ],
    weightRules: [
      v => !!v || "Peso è utile per il fattore di rischio",
      v => v.length <= 3 || "Troppo lungo"
    ],
    nameRules: [
      v => !!v || "Nome è richiesto.",
      v => v.length <= 20 || "Troppo lungo"
    ],
    requiredRules: [v => !!v || "Dato richiesto."],
    ageRange: [
      { value: 1, text: "0-5" },
      { value: 5, text: "5-19" },
      { value: 20, text: "20-29" },
      { value: 30, text: "30-39" },
      { value: 40, text: "40-49" },
      { value: 50, text: "50-59" },
      { value: 60, text: "60-70" },
      { value: 70, text: "+70" }
    ]
  })
};
</script>
